import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import LayoutNavbar from "components/common/LayoutNavbar";
import { StyledTableCell, StyledTableRow } from "components/common/Table";
import useModalLoading from "libs/hooks/useModalLoading";
import { formatDate } from "libs/utils/format";
import { get } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { setCurrentUserRole } from "redux/modules/authSlice";
import { getPersonalDetail } from "redux/modules/personalSlice";
import { imposinateUser } from "redux/modules/userSlice";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(5),
    display: "flex",
    flexDirection: "row",
  },
  title: {
    color: "#172b4d",
    fontSize: 22,
    fontWeight: "bold",
  },
  table: {
    minWidth: 600,
  },
  avatarLarge: {
    width: 150,
    height: 150,
    border: "2px solid #fff",
    backgroundColor: "#286090",
    marginTop: theme.spacing(2),
  },
  line: {
    marginTop: theme.spacing(2),
    height: 3,
    width: 50,
    backgroundColor: theme.palette.warning.main,
  },
  wrapLeftSide: {
    width: 250,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  tableCell: {
    backgroundColor: "#ffffff",
    color: "#1094d8",
    fontSize: 22,
  },
  tableContainer: {
    marginTop: theme.spacing(4),
  },
  pagination: {
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  footer: {
    marginTop: 44,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
}));

function PersonalDetailPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const modalLoading = useModalLoading();
  const history = useHistory();
  const params = useParams();

  const personalId = get(params, "personalId", "") || "";

  useEffect(() => {
    dispatch(getPersonalDetail({ personalId }));
  }, [dispatch, personalId]);

  const { detail, isLoading, isSuccess, isFailure } = useSelector(
    (state) => state.personal
  );

  useEffect(() => {
    if (isLoading) {
      modalLoading.showLoading();
    } else if (isSuccess || isFailure) {
      modalLoading.hideLoading();
    }
  }, [modalLoading, isLoading, isSuccess, isFailure]);

  const rows = [
    {
      title: ["First name", "Middle name", "Last name"],
      value: [
        get(detail, "firstname", "") || "-",
        get(detail, "middleName", "") || "-",
        get(detail, "lastName", "") || "-",
      ],
    },
    {
      title: [
        "Current Nationality /  Nationality at birth, if different",
        "Date of birth ( dd-mm-yyyy )",
        "Place of birth ( city, province/state, country )",
      ],
      value: [
        get(detail, "nationalityName", "") || "-",
        formatDate(get(detail, "birthDate", "")) || "-",
        get(detail, "placeOfBirth", "") || "-",
      ],
    },
    {
      title: ["Gender", "Marital status", ""],
      value: [
        get(detail, "gender", "") || "-",
        get(detail, "maritalStatus", "") || "-",
        "",
      ],
    },
    {
      title: [
        "Passportnumber",
        "Date of issue ( dd-mm-yyyy )",
        "Valid until( dd-mm-yyyy )",
      ],
      value: [
        get(detail, "passportNumber", "") || "-",
        formatDate(get(detail, "dateofIssue", "")) || "-",
        formatDate(get(detail, "validuntil", "")) || "-",
      ],
    },
    {
      title: ["Address in home country", "Current address in Thailand", ""],
      value: [
        get(detail, "addressInHome", "") || "-",
        get(detail, "addressInThai", "") || "-",
        "",
      ],
    },
    {
      title: ["Home / mobile phone number", "E-mail address", ""],
      value: [
        get(detail, "mobile", "") || "-",
        get(detail, "email", "") || "-",
        "",
      ],
    },
  ];

  const handleOnBack = () => history.goBack();
  const handleOnSubbmit = () => {
    history.push("/");
    dispatch(setCurrentUserRole("Agency"));
    dispatch(
      imposinateUser({
        // userID: "",
        firstname: "",
        middleName: "",
        lastName: "",
        nationalityID: "",
        nationalityName: "",
        birthDate: "",
        email: "",
        placeOfBirth: "",
        gender: "",
        passportNumber: "",
        dateofIssue: "",
        validuntil: "",
        personalUMID: "",
        visatypeID: "",
        status: false,
        ...detail,
        userID: detail.personalID,
        // personalID
        // ...
        // maritalStatus
        // addressInHome
        // addressInThai
        // mobile
      })
    );
  };

  return (
    <LayoutNavbar title="Agency / User">
      <Paper className={classes.card}>
        <div className={classes.wrapLeftSide}>
          <Typography variant="h4" className={classes.title}>
            Personal Information
          </Typography>
          <Avatar
            src="/static/images/avatar/1.jpg"
            className={classes.avatarLarge}
          />
          <div className={classes.line} />
        </div>
        <div>
          <TableContainer className={classes.tableContainer}>
            <Table>
              <TableBody>
                {rows.map((row, index) => (
                  <React.Fragment key={index}>
                    <StyledTableRow>
                      {row.title.map((title, index) => (
                        <React.Fragment key={`${title}-${index}`}>
                          <StyledTableCell className={classes.tableHead}>
                            {title || " "}
                          </StyledTableCell>
                        </React.Fragment>
                      ))}
                    </StyledTableRow>
                    <StyledTableRow>
                      {row.value.map((value, index) => (
                        <React.Fragment key={`${value}-${index}`}>
                          <StyledTableCell className={classes.tableCell}>
                            {value || " "}
                          </StyledTableCell>
                        </React.Fragment>
                      ))}
                    </StyledTableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Paper>
      <div className={classes.footer}>
        <ColorButton
          style={{ height: 40, width: 120 }}
          variant="outlined"
          color="primary"
          onClick={handleOnBack}
        >
          Back
        </ColorButton>
        <ColorButton
          style={{ height: 40, width: 120, marginLeft: 20 }}
          variant="contained"
          color="primary"
          onClick={handleOnSubbmit}
        >
          Subbmit
        </ColorButton>
      </div>
    </LayoutNavbar>
  );
}

export default PersonalDetailPage;
